import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthService } from '../../auth.service';
import { LocalStorage } from '@core/localstorage';
import { UserService } from 'src/app/modules/user/user.service';
import { NbToastrService } from '@nebular/theme';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-o-auth',
    templateUrl: './o-auth.component.html',
    styleUrls: ['./o-auth.component.scss'],
})
export class OAuthComponent implements OnInit {
    constructor(
        private route: ActivatedRoute,
        private authService: AuthService,
        private localStorage: LocalStorage,
        private userService: UserService,
        private toastrService: NbToastrService,
        private translate: TranslateService,
        private router: Router
    ) {}

    ngOnInit(): void {
        const token = this.route.snapshot.queryParamMap.get('token');
        if (!token) {
            this.router.navigate(['/home']);
            this.toastrService.danger(
                this.translate.instant('AUTH.OAUTH-ERROR'),
                this.translate.instant('ALERT.ERROR.TITLE')
            );
            return;
        }
        this.authService.oAuth(token).subscribe(
            (response) => {
                this.toastrService.success(
                    this.translate.instant('ALERT.SUCCESS.DESCRIPTION'),
                    this.translate.instant('ALERT.SUCCESS.TITLE')
                );
                this.localStorage.saveToken(response.token);
                this.userService.saveUserToLocalStorage(response.registers.usuario);
                this.router.navigate(['/home']);
            },
            (err) => {
                this.router.navigate(['/home']);
                this.toastrService.danger(
                    this.translate.instant('AUTH.OAUTH-ERROR'),
                    this.translate.instant('ALERT.ERROR.TITLE')
                );
                return;
            }
        );
    }
}
